"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getConfigFromEnv = void 0;

var _autoParse = _interopRequireDefault(require(39));

var _camelcase = _interopRequireDefault(require(70));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getConfigFromEnv = function getConfigFromEnv(env) {
  var config = {};
  Object.keys(env).forEach(function (key) {
    var curr = key.split('DOTENV_CONFIG_');

    if (curr.length === 2 && curr[0] === '' && curr[1].length) {
      config[(0, _camelcase["default"])(curr[1])] = (0, _autoParse["default"])(env[key]);
    }
  });
  return config;
};

exports.getConfigFromEnv = getConfigFromEnv;
var _default = getConfigFromEnv;
exports["default"] = _default;